import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { AuthService, BaseComponent, SettingsService } from '@nstep-common/core';
import { AppPermissions } from '@nstep-public/app/shared';

@Component({
	selector: 'app-layout',
	templateUrl: './layout.component.html',
	styleUrl: './layout.component.css',
	standalone: false
})
export class LayoutComponent extends BaseComponent implements OnInit {
	protected permissions = AppPermissions;
	serverSettings: any = {};
	totalLink: string = '';
	totalLinkName: string = 'Total Register';
	
	constructor(private authService: AuthService,
		private serverSettingsService: SettingsService,
		private router: Router) {
		super();
	}

	ngOnInit(): void {
		super.ngOnInit();
		
		if (!this.authService.jwt) {
			return;
		}

		if (this.authService.jwt?.hasTotalAccount) {
			this.totalLinkName = 'Total Login';			
		}

		this.subscriptions.push(this.serverSettingsService.getServerSettings()
			.subscribe(settings => {
				this.serverSettings = settings;
				if (this.authService.jwt?.hasTotalAccount) {
					this.totalLink = (settings as Record<string, string>)['LoginUrl'];
				} else {
					this.totalLink = (settings as Record<string, string>)['RegisterUrl'];
				}
			})
		);

		if (this.authService.redirectToUrl(this.router.url)) {
			this.router.events
				.pipe(filter(event => event instanceof NavigationEnd))
				.subscribe(() => this.authService.redirectToUrl(this.router.url));
		}
	}
}